import styled from "styled-components";

export const StyledWrapper = styled.div`
  > div:first-child {
    margin-bottom: 16px;
    > img {
      display: ${({ $showImg }) => ($showImg ? "block" : "none")};
    }
  }
`;
